import { createFileRoute } from '@tanstack/react-router';
import { DocumentsPage } from '@/features/documents';
// the schema module only: the route config is in the main bundle, the page stays in the lazy chunk
import { documentsSearchSchema } from '@/features/documents/search';

/** "Hujjatlar" / "Hisobotlar" (03-modules §5: 351:6386, 106:14439, 125:3859, 102:3311). */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/documents')({
  validateSearch: documentsSearchSchema,
  component: DocumentsRoute,
});

function DocumentsRoute() {
  const { tenant } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DocumentsPage
      tenant={tenant}
      search={search}
      onSearch={(patch, opts) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: opts?.replace })}
    />
  );
}
